import * as Sentry from '@sentry/react'
import { SENTRY_SEVERITY } from 'src/utils/sentry'
import { sanitizeSentryPage } from 'src/utils/sentry/sanitizeSentryUrl'

// ─────────────────────────────────────────────
// Flow breadcrumb
// ─────────────────────────────────────────────

type FlowAction =
  | 'join_attempt'
  | 'join_submit'
  | 'cancel_attempt'
  | 'payment_attempt'
  | 'payment_confirm'

type FlowFailAction = 'join_fail' | 'cancel_fail' | 'payment_fail'

type FlowStep = 'request' | 'response'

export function addFlowBreadcrumb(
  action: FlowAction | FlowFailAction,
  step: FlowStep,
  data?: Record<string, unknown>,
) {
  Sentry.addBreadcrumb({
    category: 'flow',
    message: `${action}[${step}]`,
    level:
      step === 'response' && data?.errCode && data.errCode !== 0
        ? SENTRY_SEVERITY.Warning
        : SENTRY_SEVERITY.Info,
    data: {
      action,
      step,
      page: sanitizeSentryPage(),
      ...data,
    },
  })
}

// ─────────────────────────────────────────────
// Bridge breadcrumb
// ─────────────────────────────────────────────

export function addBridgeBreadcrumb(
  message: string,
  data?: Record<string, unknown>,
  level?: Sentry.SeverityLevel,
) {
  Sentry.addBreadcrumb({
    category: 'bridge',
    message,
    level,
    data: {
      bridge: data?.bridge,
      phase: data?.phase,
      page: sanitizeSentryPage(),
      ...data,
    },
  })
}
